import { render, staticRenderFns } from "./caseClosed.vue?vue&type=template&id=72371a52&"
import script from "./caseClosed.vue?vue&type=script&lang=js&"
export * from "./caseClosed.vue?vue&type=script&lang=js&"
import style0 from "./caseClosed.vue?vue&type=style&index=0&id=72371a52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports